import React from "react";
import AgeRestrictionPage from "./components/AgeRestrictionPage"; // Path to the component
import BackgroundSection from "./components/BackgroundSection"; // Path to the component

const App = () => {
  return (
    <AgeRestrictionPage>
      <BackgroundSection />
    </AgeRestrictionPage>
  );
};

export default App;